/* eslint-disable jira/filename-case */
import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): string[] {
		// eslint-disable-next-line jira/ff/inline-expVal-params -- ESLint rule doesn't understand the array type
		return expVal('ttvc_dimensions_issue_view', 'value', [
			'Embedded Issue View',
			'Full Issue View',
		]);
	},
};
